import React from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const colorMap = {
  blue: "#066FEF",
  gray: "#333333",
  grey: "#333333",
};

const MotionMinus = ({ color = "blue", ...props }) => {
  const resolvedColor = colorMap[color] || color;
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 48 48"
      htmlColor={resolvedColor}
      shapeRendering="crispEdges"
    >
      <path d="M10.8006 25.1996V22.7996H37.2006V25.1996L10.8006 25.1996Z" />
    </SvgIcon>
  );
};

MotionMinus.propTypes = {
  color: PropTypes.string,
};

export default MotionMinus;
